/* eslint-disable */
import axios from '../index'

const getAll = () => {
  return axios.get('slides/all')
}

const api = { getAll }


export default api;